import { type InvitePeopleProps } from '../../types';

export type PassThroughInvitePeopleProps = Omit<InvitePeopleProps, 'viewAs'>;

export type InvitePeopleDrawerProps = PassThroughInvitePeopleProps & {
	isOpen: boolean;
	onCloseHandler: () => void;
};

export enum TestId {
	InvitePeopleDrawer = 'testId-invite-people-drawer',
	InvitePeopleDrawerContent = 'testId-invite-people-drawer-content',
	InvitePeopleDrawerImage = 'testId-invite-people-drawer-img',
	InvitePeopleForm = 'testId-invite-people-form',
}
